import React, { Component } from "react";
import JoditEditor from "jodit-react";

const config = {
  readonly: false, // all options from https://xdsoft.net/jodit/doc/
  fullSize: false,
  removeButtons: [
    "file",
    "about",
    "copyformat",
    "print",
    "image",
    "table",
    "video",
    "source",
  ],
  showTooltip: true,
  uploader: {
    insertImageAsBase64URI: true,
    // url: "www.google.com"
  },
};

class SystemExamExplanation extends Component {
  state = {};
  render() {
    const { type } = this.props;
    return (
      <div>
        <JoditEditor
          onChange={(e) =>
            this.props.handleExplanation(e, this.props.idx, type)
          }
          value={this.props.explanation}
          config={config}
        />
        <div className="text-end mt-2">
          <button
            className="btn btn-primary cusBtn cusBtnFontSize mr-3"
            onClick={this.props.saveExplanation}
          >
            Save
          </button>
          <button
            className="btn btn-primary cusBtn cusBtnFontSize"
            onClick={(e) =>
              this.props.closeExplanation(e, this.props.idx, type)
            }
          >
            Cancel
          </button>
        </div>
      </div>
    );
  }
}

export default SystemExamExplanation;
